import { on } from 'delegated-events';

// pasek w jednej linii (.scroll-row z [data-scroll-list]): palcem albo strzalkami na desktopie;
// can-prev/can-next wlaczaja strzalke i wygaszenie tylko po stronie, z ktorej cos wystaje
const ROW = '.scroll-row';
const LIST = '[data-scroll-list]';
const STEP = 0.7;

function update(row, list) {
    const max = list.scrollWidth - list.clientWidth;

    row.classList.toggle('can-prev', list.scrollLeft > 1);
    row.classList.toggle('can-next', list.scrollLeft < max - 1);
}

function centerSelected(list) {
    const selected = list.querySelector('.selected');
    if (!selected) return;

    const item = selected.getBoundingClientRect();
    const box = list.getBoundingClientRect();

    list.scrollLeft += item.left - box.left - (box.width - item.width) / 2;
}

function bind(row) {
    if (row.hasAttribute('data-scroll-bound')) return;
    row.setAttribute('data-scroll-bound', '');

    const list = row.querySelector(LIST);
    const refresh = () => update(row, list);

    list.addEventListener('scroll', refresh, { passive: true });
    new ResizeObserver(refresh).observe(list);
    // pigulki przebudowuje create-pills
    new MutationObserver(refresh).observe(list, { childList: true, subtree: true });

    centerSelected(list);
    refresh();
}

function rows() {
    return [...document.querySelectorAll(ROW)];
}

export default function () {
    let scrolled = [];

    rows().forEach(bind);

    // pjax podmienia listing - pasek zostaje tam, gdzie klient go przewinal
    document.addEventListener('pjax:send', function () {
        scrolled = rows().map(row => row.querySelector(LIST).scrollLeft);
    });

    document.addEventListener('pjax:complete', function () {
        rows().forEach(bind);

        requestAnimationFrame(() => {
            rows().forEach((row, index) => {
                if (scrolled[index]) row.querySelector(LIST).scrollLeft = scrolled[index];
            });
        });
    });

    on('click', '.scroll-row-arrow', function () {
        const list = this.closest(ROW).querySelector(LIST);
        const direction = this.classList.contains('next') ? 1 : -1;

        list.scrollBy({ left: direction * list.clientWidth * STEP, behavior: 'smooth' });
    });
}
